import { CSSProperties } from 'react';

export function isSubtotalRow(row: any): boolean {
  return row.original && row.original.isSubtotal;
}

export function formatExportData(table: any, headers: any[]) {
  return table
    .getFilteredRowModel()
    .rows.filter((row: any) => !isSubtotalRow(row))
    .map((row: any) => {
      const rowData: Record<string, any> = {};
      headers.forEach((header) => {
        const cell = row
          .getVisibleCells()
          .find((cell: any) => cell.column.id === header.key);

        if (!cell) {
          rowData[header.key] = null;
          return;
        }

        const rawValue = cell.getValue();
        let finalValue;

        if (header.key === 'crmTractName' || header.key === 'crmSubtractName') {
          finalValue = rawValue || '';
        } else if (rawValue && typeof rawValue === 'object') {
          if ('value' in rawValue) {
            finalValue = rawValue.value;
          } else if ('entityName' in rawValue) {
            finalValue = rawValue.entityName;
          } else if ('content' in rawValue) {
            finalValue =
              typeof rawValue.content === 'object'
                ? rawValue.content.props?.children || ''
                : rawValue.content;
          } else {
            // For other objects, try to get a meaningful string value
            const rendered = cell.column.columnDef.cell(cell.getContext());
            if (
              rendered &&
              typeof rendered === 'object' &&
              'props' in rendered
            ) {
              finalValue = rendered.props.children || '';
            } else {
              finalValue = rendered || JSON.stringify(rawValue) || '';
            }
          }
        } else {
          finalValue = rawValue === undefined ? '' : rawValue;
        }

        rowData[header.key] = typeof finalValue === 'object' ? '' : finalValue;
      });
      return rowData;
    });
}

export function emptyPinStyleGenerator(): CSSProperties {
  return {};
}
